<template>
    <div class="container">
        <div class="whiteCover"></div>
        <div class="top-wrapper">
            <div class="nav-item" id="left-nav-item" @click="goSetting" style="top: 1.45rem;">
              <img src="../../../assets/image/member/setting.svg" class="nav-icon">
            </div>
            <div class="nav-item" id="right-nav-item" style="right: 2.5rem">
              <img src="@/assets/image/member/shopcart.svg" class="nav-icon" style="width: 41px; height: 36px">
            </div>
            <div class="nav-item" id="right-nav-item" @click="goNews()" style="top: 1.45rem;">
              <img src="../../../assets/image/member/news.svg" class="nav-icon">
              <i class='notice' v-if='1'><span class='notice_text'>{{ user.new_message_count > 99? 99 : user.new_message_count }}</span></i>
            </div>
            <div class="top-info-wrapper">
                <div class="avatar-wrapper" @click="goProfileInfo">
                    <img class="avatar" v-bind:src="user.member_avatar+'?'+time" v-if="isOnline && user && user.member_avatar"/>
                </div>
               <p class="nickname"  @click="goProfileInfo" >{{ nickname }}<img :src="user.level_icon" style="height: 1rem; width: 1rem; margin: -4px 10px 0; position: absolute;" /></p>
            </div>
            <div class="info-wrapper">
              <div class="info-item" @click="goPredeposit">
                <div class="item">{{ $t('member.balance') }}</div>
                <div class="item price">{{ $t('general.dollar_sign') }}{{ utils.currencyPrice(getAvailablePredeposit) }}</div>
              </div>
              <div class="info-item" @click="goScoreList">
                <div class="item">{{ $t('member.point') }}</div>
                <div class="item price">{{ utils.currencyPrice(getScore) }}</div>
              </div>
            </div>
        </div>
        <flex-line class="order-header" :is-link="true" style="padding-top: 3rem;margin-top:0;" @click.native="goOrder">
          <span>{{ $t('member.my_order') }}</span>
          <span slot="right">{{ $t('member.check_all_orders') }}</span>
        </flex-line>
        <div class="order-wrapper" >
            <index-order-item
              class="order-item"
              testAttr="MemberOrderList"
              :id="OrderState.NEW"
              :src="require('../../../assets/image/member/chufa.svg')"
              :title="this.$t('order.status.non_payment')"
              :orderNumber="user.order_nopay_count"
            >
            </index-order-item>
            <index-order-item
                    class="order-item"
                    testAttr = 'MemberOrderList'
                    :id="getStatesString([OrderState.PAY, OrderState.RECEIPT])"
                    :src="require('../../../assets/image/member/qucan.svg')"
                    :title="this.$t('order.status.confirm')"
                    :orderNumber='user.order_noship_count'>
            </index-order-item>
            <index-order-item
                    class="order-item"
                    testAttr = 'MemberOrderList'
                    :id='getStatesString([OrderState.OCCUPY, OrderState.DELIVER, OrderState.SEND])'
                    :src="require('../../../assets/image/member/waisong.svg')"
                    :title="this.$t('order.status.pending')"
                    :orderNumber='user.order_noreceipt_count'>
            </index-order-item>
            <index-order-item
                    class="order-item"
                    testAttr = 'MemberOrderList'
                    :id="'&no_evaluation=true'"
                    :src="require('../../../assets/image/member/pingjia.svg')"
                    :title="this.$t('order.status.no_comment')"
                    :orderNumber = 'user.order_noeval_count'>
            </index-order-item>
        </div>
        <!-- <flex-line class="order-header">
          <span>跑腿服务</span>
        </flex-line>
        <div class="manage-wrapper">
            <index-manage-item
                    v-on:onclick="$router.push({name:'MemberO2oErrand'})"
                    :src="require('../../../assets/image/member/icon_paotuigeren_pre.png')"
                    title="跑腿"
            >
            </index-manage-item>
            <index-manage-item
                    v-on:onclick="$router.push({name:'MemberO2oFuwuOrderList'})"
                    :src="require('../../../assets/image/member/icon_order_pre.png')"
                    title="服务订单"
            >
            </index-manage-item>
        </div> -->
        <flex-line class="order-header">
          <span>{{ $t('member.tools') }}</span>
        </flex-line>
        <div class="manage-wrapper">
            <index-manage-item
                    v-on:onclick="goAccount"
                    :src="require('../../../assets/image/member/purse.svg')"
                    :title="this.$t('tool.wallet')"
            >
            </index-manage-item>
            <index-manage-item
                    v-on:onclick="redirectListCreditCards()"
                    :src="require('../../../assets/image/member/card.svg')"
                    :title="this.$t('tool.credit')"
            >
            </index-manage-item>
            <index-manage-item
                    v-if="config.points_isuse === '1' && config.points_signin_isuse === '1'"
                    v-on:onclick="$router.push({name:'MemberPointSignin'})"
                    :src="require('../../../assets/image/member/signin.svg')"
                    :title="this.$t('tool.attendance_book')"
            >
            </index-manage-item>
            <index-manage-item
                    v-if="config.inviter_open === '1'"
                    v-on:onclick="openInviteFriendsModal({})"
                    :src="require('../../../assets/image/member/popularize.svg')"
                    :title="this.$t('tool.share')"
            >
            </index-manage-item>
            <!-- <index-manage-item
                    v-on:onclick="$router.push({name:'MemberAuth'})"
                    :src="require('../../../assets/image/member/testimony.svg')"
                    title="实名认证"
            >
            </index-manage-item> -->
            <index-manage-item
                    v-on:onclick="goFavourite()"
                    :src="require('../../../assets/image/member/collect.svg')"
                    :title="this.$t('tool.favorite')"
            >
            </index-manage-item>
            <!-- <index-manage-item
                    v-on:onclick="goRefund()"
                    :src="require('../../../assets/image/member/refund.svg')"
                    :title="this.$t('tool.refund')"
            >
            </index-manage-item> -->
            <index-manage-item
                    v-on:onclick="goInvoice()"
                    :src="require('../../../assets/image/member/invoice.svg')"
                    :title="this.$t('tool.invoice')"
            >
            </index-manage-item>
            <index-manage-item
                    v-on:onclick="goAddress()"
                    :src="require('../../../assets/image/member/address.svg')"
                    :title="this.$t('tool.address')"
            >
            </index-manage-item>
            <index-manage-item
                    v-on:onclick="goEvaluateList()"
                    :src="require('../../../assets/image/member/judgea.svg')"
                    :title="this.$t('tool.comment')"
            >
            </index-manage-item>
            <index-manage-item
                    v-on:onclick="goMarketmanagelog()"
                    :src="require('../../../assets/image/member/exercise.svg')"
                    :title="this.$t('tool.activity')"
            >
            </index-manage-item>
            <index-manage-item
                    v-on:onclick="goBrowse()"
                    :src="require('../../../assets/image/member/footprint.svg')"
                    :title="this.$t('tool.viewed')"
            >
            </index-manage-item>
            <index-manage-item
                    v-on:onclick="goMemberFeedback()"
                    :src="require('../../../assets/image/member/feedback.svg')"
                    :title="this.$t('tool.feedback')"
            >
            </index-manage-item>
        </div>

        <div class="bottom-wrapper">
          <div class="title">{{ $t('member.like') }}</div>
          <!-- <flex-line
            v-if="user.store_id"
            @click.native="goSellerInfo"
            :is-link="true"
          >
            <div>
              <img class="item-icon" src="../../../assets/image/member/icon_shop_seller_nor.png" />
              <span>店铺管理</span>
            </div>
          </flex-line>
          <div v-else>
          <flex-line
            v-if="config && config.store_joinin_open!=0"
            @click.native="goSellerJoinin"
            :is-link="true"
          >
            <div>
              <img class="item-icon" src="../../../assets/image/member/icon_shop_seller_nor.png" />
              <span>商家入驻</span>
            </div>
          </flex-line>
          </div> -->

        </div>
        <!-- <guess-like :title="true"></guess-like> -->
        <index-ad :items='ad'></index-ad>
    </div>
</template>

<script>
import { OrderState } from '@/const/order'
import { Toast } from 'mint-ui'
import IndexInfoItem from './IndexInfoItem'
import IndexOrderItem from './IndexOrderItem'
import IndexManageItem from './IndexManageItem'
// import GuessLike from '../../GuessLike'
import IndexAd from '../../home/index/IndexAd'
import { mapState, mapActions, mapMutations } from 'vuex'
import { getMemberIndex } from '../../../api/member'
import { checkInviter } from '../../../api/memberInviter'
import flexLine from '../../flexLine'
import { Position } from '@/const/appadv'
import { getAppadList } from '../../../api/homeindex'

export default {
  name: 'MemberIndex',
  data () {
    return {
      OrderState,
      user: {},
      time:'',
      orderCount: {},
      isShow: true,
      ad: '',
    }
  },
  components: {
    IndexOrderItem,
    IndexInfoItem,
    IndexManageItem,
    flexLine,
    // GuessLike,
    IndexAd,
  },
  mounted() {    
    if (!this.member) {      
      this.$router.push({name: 'HomeMemberLogin'});
    }
  },
  created: function () {
    this.time = new Date().getTime();
    if (this.isOnline) {
      getMemberIndex().then(response => {
        if (response && response.result.member_info) {
          this.user = response.result.member_info
        }
      }, error => {}
      )

      if(this.friendInvitationCode && this.member.invitation_code !== this.friendInvitationCode && !this.member.inviter_id) {
        this.openInviteFriendsModal()
      }
    }
    getAppadList(Position.MY_ADV_ID).then(
      (response) => {
      if (response.result && response.result.ad_list) {
        this.ad = response.result.ad_list
      }
    })
  },
  computed: {
    ...mapState({
      isOnline: state => state.member.isOnline,
      config: state => state.config.config,
      friendInvitationCode: state => state.member.friend_invitation_code,
      member: state => state.member.info
    }),
    nickname () {
      let title = `${this.$t('login.login')}/${this.$t('register.register')}`
      if (this.isOnline) {
        if (this.user && typeof this.user !== 'undefined' && JSON.stringify(this.user) != '{}') {
          title = this.user.member_nickname
        }
      }
      return title
    },
    getScore () {
      let score = '0'
      if (this.isOnline && this.user.member_points) {
        score = this.user.member_points
      }
      return score
    },
    // 预存款可用金额 通过store 进行获取
    getAvailablePredeposit () {
      let availablePredeposit = '0.00'
      if (this.isOnline && this.user.available_predeposit) {
        availablePredeposit = this.user.available_predeposit
      }
      return availablePredeposit
    },
    getlevelname () {
      let levelname  = ''
      if (this.isOnline && this.user.level_name) {
        levelname = this.user.level_name
      }
      return levelname
    }
  },
  methods: {
    ...mapActions([
        'openInviteFriendsModal',
    ]),
    ...mapMutations([
        'setFriendInvitationCode'
    ]),
    redirectListCreditCards () {
        this.$router.push({ name: 'MemberCredits' })
    },
	getStatesString (states) {
		return states.join(',')
	},
    showLogin () {
      this.$router.push({ name: 'HomeMemberLogin' })
    },
    goScoreList () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberPointList', query: { index: 0 } })
      } else {
        this.showLogin()
      }
    },
    goOrder () {
      if (this.isOnline) {
        this.$router.push({
          name: 'MemberOrderList'
        })
      } else {
        this.showLogin()
      }
    },
    goProfileInfo () {
      if (this.isOnline) {
        this.$router.push({ 'name': 'MemberProfileSet' })
      } else {
        this.showLogin()
      }
    },
    goSetting () {
      this.$router.push({ name: 'MemberSetting' })
    },
    goNews () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberNoticeList' })
      } else {
        this.showLogin()
      }
    },
    goFavourite () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberFavorite' })
      } else {
        this.showLogin()
      }
    },
    goAddress () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberAddressList', query: {
          o2o_errand_type: 0,
          from: 'member_profile'
        } })
      } else {
        this.showLogin()
      }
    },
    goRefund () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberRefundList' })
      } else {
        this.showLogin()
      }
    },
    goAccount () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberAccount' })
      }else {
        this.showLogin()
      }
    },
    goPredeposit () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberPredepositList' })
      } else {
        this.showLogin()
      }
    },
    // 我的订单评价
    goEvaluateList () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberEvaluateList' })
      } else {
        this.showLogin()
      }
    },
    // 发票管理
    goInvoice () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberInvoiceList' })
      } else {
        this.showLogin()
      }
    },
    // 浏览历史
    goBrowse () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberBrowseList' })
      } else {
        this.showLogin()
      }
    },
      // 意见反馈
      goMemberFeedback () {
        if (this.isOnline) {
          this.$router.push({ name: 'MemberFeedback' })
        } else {
          this.showLogin()
        }
      },
    goSellerInfo () {
      if (this.isOnline) {
        this.$router.push({ name: 'SellerIndex' })
      } else {
        this.showLogin()
      }
    },
    // 分销管理中心
    goMemberInviterManage () {
      if (this.isOnline) {
        checkInviter().then(res => {
          this.$router.push({ name: 'MemberInviterManage' })
        }).catch(function (error) {
          Toast(error.message)
        })
      } else {
        this.showLogin()
      }
    },
    // 商家入驻
    goSellerJoinin () {
      if (this.isOnline) {
        this.$router.push({ name: 'SellerJoinin1' })
      } else {
        this.showLogin()
      }
    },
    // 活动记录
    goMarketmanagelog () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberMarketmanagelog' })
      } else {
        this.showLogin()
      }
    },
  }
}
</script>

<style scoped lang="scss">
    .whiteCover {
      position: absolute;
      width: 100%;
      height: 80px;
      background: white;
      top: 30%;
      z-index: 700;
    }
    .container {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        background-color: #f0f2f5;
        .top-wrapper {
          position:relative;
          padding-top: 2.5rem;
          height: 9rem;
          border-radius: 0 0 30px 30px;
          background: #f4c41e;
          z-index: 950;
          .top-info-wrapper {
            flex: 1;
            width: 100%;
            text-align: center;
          }
        }
    .nav-item {
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      top:1.2rem;
      .notice {
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        width: .7rem;
        height: .7rem;
        background-color: #e93b3d;
        border-radius: 50%;
        .notice_text {
          color: white;
          font-size: 5px;
          background-color: #0000;
          top: 2px;
          right: 0;
          display: block;
          position: absolute;
          text-align: center;
          width: .7rem;
        }
      }
    }
    #left-nav-item {
      left: 0.5rem;
    }
    #right-nav-item {
      right: 0.5rem;
    }
    .nav-icon {
      width: 1.3rem;
      height: 1.3rem;
      text-align: center;
      color: #fff;
    }
    .avatar-wrapper {
      position:relative;
      width: 4rem;
      height: 4rem;
      border-radius: 50%;
      background-color: #fff;
      margin:0 auto;
      margin-top: 1rem;
      .avatar {
        width: 3.6rem;
        height: 3.6rem;
        border-radius: 50%;
        position:absolute;
        top:.2rem;
        left:.2rem;
      }
    }
    .nickname {
      width: 100%;
      margin-top: 1rem;
      font-size: $subFontSize;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      margin-left: 0;
      margin-right: 0;
    }
    .info-wrapper {
      position: absolute;
      bottom:-2rem;
      left:1.5rem;
      right:1.5rem;
      display: inline-flex;
      flex-direction: row;
      justify-content: flex-start;
      align-content: stretch;
      background-color: #fff;
      border-radius: .4rem;
      box-shadow: 0px 4px 4px #f7f7f7;
      z-index: 1000;
    }
    .info-item {
      flex: 1;
      text-align: center;
      font-size: $h2;
      color:$formInputColor;
      position: relative;
      &:first-child::after{content:'';position: absolute;top:.5rem;bottom:.5rem;right:0;border-right: 1px dashed #eee;}
      .item{padding-top:.5rem;}
      .price{color:$priceColor;padding-bottom:.5rem;}
    }
    .order-header {
      background-color: #fff;
      padding:0 $pageSpace;
      margin-top:$modelSpace;
      z-index: 900;
    }
    .order-header-item {
        flex: 1;
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    #order-item-left {
        justify-content: flex-start;
        margin-left: 0.5rem;
    }
    #order-item-right {
        justify-content: flex-end;
    }
    .item-title {
      font-size: $subFontSize;
      color: $formInputColor;
      font-weight:700;
    }

    .order-subtitle {
      font-size: $fontSize;
      color: $descTextColor;
    }
    .order-wrapper {
        height: 4.4rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: stretch;
        background-color: #fff;
    }
    .order-item {
        flex: 1;
    }
    .bottom-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: stretch;
      margin-top:$modelSpace;
      // margin-bottom:$modelSpace;
      background: #fff;
      padding:0 $pageSpace;
      .item-icon{
        width:1.2rem;
        height:1.2rem;
        margin-right: .4rem;
      }
      .left span{
          vertical-align: super;
          font-weight: 700;
      }
      .title {
        text-align: center;
        position: relative;
        font-size: .85rem;
        color: #000;
        font-weight: 700;
        padding-top: 1rem;
        padding-bottom: 1rem;
      }
    }
    .manage-wrapper {
        background: #fff;
        padding-bottom: 15px;
    }
}
</style>
